import Model from "flarum/Model";

export default class U2DiInfoQueries extends Model {}
Object.assign(U2DiInfoQueries.prototype, {
  id: Model.attribute("id"),
  base_id: Model.attribute("base_id"),
  userID: Model.attribute("userID"),
  nID: Model.attribute("nid"),
  xdxx: Model.attribute("xdxx"),
  contacted: Model.attribute("contacted"),
  completed: Model.attribute("completed"),
  note: Model.attribute("note"),
  attachment: Model.attribute("attachment"),
  assignedAt: Model.attribute("assignedAt"),
  u2diDetailsData: Model.hasOne("u2diDetailsData"),
  u2diBaseData: Model.hasOne("u2diBaseData"),
  u2diUserData: Model.hasOne("u2diUserData"),
  u2diReportData: Model.hasMany("u2diReportData"),
});